<!--
 * @Author: taosong
 * @Date: 2021-03-11 15:25:14
 * @LastEditors: taosong
 * @LastEditTime: 2021-04-15 13:09:40
 * @Description: taosongs
-->
<template>
  <div class="order-container">
    <common-header
      fontColor="#333"
      content="订单详情"
      backgrounds="#fff"
    ></common-header>
    <div class="order-list">
      <div class="order-list-title">
        <img :src="report" alt="答题明细报告" />
        <h4>{{ productObj.prodName }}</h4>
      </div>
      <div class="order-list-content">
        <div class="order-list-content-row">
          <span class="key">科目</span>
          <span class="value">{{ store.state.subjectName }}</span>
        </div>
        <div class="order-list-content-row">
          <span class="key">准考证号</span>
          <span class="value">{{ store.state.perm }}</span>
        </div>
        <div class="order-list-content-row">
          <span class="key">价格</span>
          <span class="value price">￥{{ productObj.price }}</span>
        </div>
      </div>
    </div>
    <common-report-explain class="export"></common-report-explain>
    <div class="purchase-container">
      <span>￥{{ productObj.price }}</span>
      <div @click="canClickBuy && buyNowClick()" class="purchase">立即购买</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import report from "img/report.png";
import commonHeader from "../../components/commonHeader.vue";
import CommonReportExplain from "../../components/commonReportExplain.vue";
// import Cookies from 'js-cookie'
// import stores from 'store'
import { jumpOnlinePayment } from "../../api/index";
import { computed, ref } from "vue";
import { useStore } from "vuex";
export default {
  components: { commonHeader, CommonReportExplain },
  name: "OrderDetails",
  setup() {
    // 定义store
    const store = useStore();
    // 定义商品信息对象
    const productObj = computed(() => store.state.productMsg);
    // 定义一个状态当立即购买之后不允许在次点击
    const canClickBuy = ref(true);

    // 立即购买
    const buyNowClick = async () => {
      canClickBuy.value = false;
      try {
        const { code, data } = await jumpOnlinePayment(
          store.state.batchCode,
          store.state.perm,
          productObj.value.id
        );
        if (code === 0) {
          window.location.href = data;
        } else {
          Toast.fail({
            message: "支付跳转失败",
            duration: 5000,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    return {
      report,
      productObj,
      store,
      buyNowClick,
      canClickBuy,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/color.scss";
@import "scss/base.scss";
.order-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .order-list {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 702px;
    height: 330px;
    background: #ffffff;
    border-radius: 16px;
    &-title {
      display: flex;
      align-items: center;
      height: 100px;
      border-bottom: 2px solid #eee;
      padding-left: 30px;
      box-sizing: border-box;
      img {
        width: 48px;
        height: 48px;
      }
      h4 {
        font-size: 34px;
        font-weight: bold;
        margin-left: 20px;
      }
    }
  }
  .export {
    padding-bottom: 25%;
  }
  .order-list-content {
    display: flex;
    flex: 1;
    justify-content: space-around;
    padding: 20px 30px;
    flex-direction: column;
    &-row {
      display: flex;
      width: 100%;
      justify-content: space-between;
      .key {
        font-size: 32px;
        color: $color-gray;
      }
      .value {
        font-size: 32px;
        color: #333;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: right;
        width: 70%;
        &.price {
          color: var(--primary-color);
        }
      }
    }
  }
  .purchase-container {
    position: fixed;
    bottom: 1px;
    left: 0;
    right: 0;
    height: 100px;
    background-color: #fff;
    border-bottom: 2px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    span {
      color: var(--primary-color);
      font-size: 32px;
    }
    .purchase {
      @include flex-center;
      background-color: var(--primary-color);
      font-size: 32px;
      color: #fff;
      width: 232px;
      height: 72px;
      border-radius: 36px;
    }
  }
}
</style>
